import _ from "lodash";
import { FEEDERLISTS, PENDINGISSUE } from "../_constants/actionConstants";

const initialState = {
  projPendingIssueLists: {}, // Normalized by projectId
  openPendingIssueDetails: {}, // Normalized by projectId, then by pendingIssueId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
  updating: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PENDINGISSUE.FETCH_ALL:
    case PENDINGISSUE.FETCH_DETAILS:
      return { ...state, fetching: true };

    case PENDINGISSUE.ADD:
    case PENDINGISSUE.DELETE:
    case PENDINGISSUE.EDIT:
      return { ...state, updating: true };

    case PENDINGISSUE.ADD_FULFILLED:
    case PENDINGISSUE.ADD_REJECTED:
    case PENDINGISSUE.EDIT_REJECTED:
    case PENDINGISSUE.DELETE_FULFILLED:
      return { ...state, updating: false };

    case FEEDERLISTS.FETCH_FULFILLED:
    case PENDINGISSUE.FETCH_ALL_FULFILLED: {
      const { projectId, projPendingIssueList } = action;
      if (!projectId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        projPendingIssueLists: {
          ...state.projPendingIssueLists,
          [projectId]: projPendingIssueList,
        },
      };
    }

    case PENDINGISSUE.EDIT_FULFILLED:
    case PENDINGISSUE.FETCH_DETAILS_FULFILLED: {
      const { projectId, pendingIssueId, pendingIssueDetails } = action;
      if (!projectId || !pendingIssueId || !pendingIssueDetails)
        return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openPendingIssueDetails: {
          ...state.openPendingIssueDetails,
          [projectId]: {
            ...state.openPendingIssueDetails,
            [pendingIssueId]: pendingIssueDetails,
          },
        },
      };
    }

    case PENDINGISSUE.CLEAR_DETAILS: {
      const { projectId, pendingIssueId } = action;
      if (
        !projectId ||
        !pendingIssueId ||
        !(projectId in state.openPendingIssueDetails) ||
        !(pendingIssueId in state.openPendingIssueDetails[projectId])
      )
        return { ...state, fetching: false };

      let openPendingIssueDetails = _.cloneDeep(state.openPendingIssueDetails);
      delete openPendingIssueDetails[projectId][pendingIssueId];

      return { ...state, fetching: false, openPendingIssueDetails };
    }

    default:
      return { ...state };
  }
};
